import * as React from "react"
/**
 *  Value is update after given delay (ms)
 * @param value
 * @param delay in milliseconds
 * @returns
 */
function useDebounce<T>(value: T, delay: number) {
  const [debouncedValue, setDebouncedValue] = React.useState(value)
  const previousValueRef = React.useRef(value)

  React.useEffect(() => {
    if (isEqual(previousValueRef.current, value)) {
      return
    }

    const handler = setTimeout(() => {
      previousValueRef.current = value
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

export default useDebounce

function isEqual(a: any, b: any) {
  return JSON.stringify(a) === JSON.stringify(b)
}